import { call, put, takeLatest } from 'redux-saga/effects'
import api from '../../services/api'
import history from '../history'

function* validateToken(action) {
  try {
    const result = yield call(api.validateToken)
    yield put({ type: 'TOKEN_VALIDATION_SUCCEEDED', payload: result })
  } catch (e) {
    yield put({ type: 'TOKEN_VALIDATION_FAILED', payload: e })
    window.localStorage.clear()
    history.push('/login')
  }
}

function* tokenValidation() {
  yield takeLatest('TOKEN_VALIDATION_REQUESTED', validateToken)
}

export default tokenValidation
